import React from 'react';
import { Mail, DollarSign, Headphones, Link, GitHub, Award, Activity, Heart } from 'react-feather';
import { Card, CardBody, Col } from 'reactstrap';
import { Badges } from '../../../../AbstractElements';
import { TagsWithIcon } from '../../../../Constant';
import HeaderCard from '../../../Common/HeaderCard';

const TagWithIcon = () => {
  return (
    <Col sm='12' xl='6'>
      <Card>
        <HeaderCard title={TagsWithIcon} />
        <CardBody>
          <Badges color='primary' href='#javascript'>
            <DollarSign />
          </Badges>
          <Badges color='secondary' href='#javascript'>
            <Headphones />
          </Badges>
          <Badges color='success' href='#javascript'>
            <Link />
          </Badges>
          <Badges color='info' href='#javascript'>
            <GitHub />
          </Badges>
          <Badges className='text-dark' color='warning' href='#javascript'>
            <Award />
          </Badges>
          <Badges color='danger' href='#javascript'>
            <Activity />
          </Badges>
          <Badges className='text-dark' color='light' href='#javascript'>
            <Heart />
          </Badges>
          <Badges color='dark' href='#javascript'>
            <Mail />
          </Badges>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TagWithIcon;
